<template>
	<modal-dialog
		:modal-visible="visible"
		:title="title"
		confirm-button-text="Save"
		v-on:confirm="save"
		v-on:closeModal="closeModal">

		<field v-if="contextCategoryId !== 0"
			:readonly="contextCategoryId !== null" 
			label="Parent Category" 
			col-class="col-sm-4" 
			:params="{type: 'select',options: catOptions}" 
			v-model="payload.category_id">	
		</field>
		<field v-else
			:readonly="true" 
			label="Parent Category" 
			col-class="col-sm-4" 
			:params="{type:'text'}"
			value="Top Level Category">	
		</field>

		<field label="Category Name" col-class="col-sm-4"  v-model="payload.name"></field>

	</modal-dialog>
</template>
<script type="text/javascript">
import ModalDialog from "../ModalDialog"
import Field from "../Field"
	
export default {
	name: "DatabaseCategoryEditModal",
	components: {
		ModalDialog,
		Field
	},
	props: ["visible",
		"title",
		"record",
		"catOptions",
		"apiResource",
		"contextCategoryId" //can be used to pass in a pre-selected category (if not null, category selector is readonly)
	],
	data() {
		return {
			payload: {}
		}
	},
	watch: {
		record() {
			this.payload = this.record
		},
		contextCategoryId() {
			this.payload.category_id = this.contextCategoryId
		}
	},
	methods: {
		closeModal() {
			this.$emit("closeModal")
		},
		save() {
			let vm = this

			this.saveRecord(this.apiResource,this.payload,response => {
				vm.alertSaved("Category saved!")
				vm.$emit("closeModal")
				vm.$emit("modelChanged")
			})
		}
	},
	created() {
		if (this.record)
			this.payload = this.record

		if (this.contextCategoryId)
			this.payload.category_id = this.contextCategoryId

	}
}	
</script>